import {
  IDataBadgeAchievementList,
  IGroupBadgeAchievementList
} from '../redux/getBadgeAchievementListSilce';
import {
  IDataEmailReportingList,
  IGroupEmailReportingList
} from '../redux/getEmailReportingListSilce';
import {
  IDataTrainingCompletionList,
  IGroupTrainingCompletionList
} from '../redux/getTrainingCompletionSilce';

/**
 * Leaderboard Types and Interfaces
 */
export enum LeaderboardType {
  EMAIL_REPORTING = 'EMAIL_REPORTING',
  COURSE_COMPLETION = 'COURSE_COMPLETION',
  ACHIEVEMENT_COMPLETION = 'ACHIEVEMENT_COMPLETION'
}

export interface PeriodModel {
  from?: string;
  to?: string;
}

export interface LeaderboardTabsList {
  type: string;
  label: string;
}

export interface PaginationModel {
  limit: number;
  offset: number;
  has_more: boolean;
}

// Email Reporting Leaderboard

export interface EmailReportingRanking {
  rank: number;
  learner_id: number;
  learner_email: string;
  first_name: string;
  last_name: string;
  segment: string;
  total_points: number;
  report_count: number;
  average_response_time_minutes: number;
}

export interface EmailReportingLeaderboardResponse {
  leaderboard_type: string;
  cell_id: number;
  period: PeriodModel;
  total_learners: number;
  rankings: EmailReportingRanking[];
  pagination: PaginationModel;
}

// Training Completion Leaderboard

export interface TrainingCompletionRanking {
  rank: number;
  learner_id: number;
  learner_email: string;
  first_name: string;
  last_name: string;
  segment: string;
  total_points: number;
  completion_percentage: number;
  courses_completed: number;
  courses_assigned: number;
}

export interface TrainingCompletionLeaderboardResponse {
  leaderboard_type: string;
  cell_id: number;
  period: PeriodModel;
  total_learners: number;
  rankings: TrainingCompletionRanking[];
  pagination: PaginationModel;
}

// Badge Achievement Leaderboard

export interface RecentBadge {
  badge_id: string;
  badge_name: string;
  tier: string;
  unlocked_at: string;
}

export interface BadgeAchievementRanking {
  rank: number;
  learner_id: number;
  learner_email: string;
  first_name: string;
  last_name: string;
  segment: string;
  total_points: number;
  total_badges: number;
  badges_acquired: number;
  badges_remaining: number;
  badges_by_tier: Record<string, number>;
  recent_badges: RecentBadge[];
}

export interface BadgeAchievementLeaderboardResponse {
  leaderboard_type: string;
  cell_id: number;
  total_learners: number;
  rankings: BadgeAchievementRanking[];
  pagination: PaginationModel;
}

// Highlights

export interface Highlight {
  id: number | string;
  name: string;
  rank: number;
  points: number | string;
  point_type: string;
  metric_type: string;
}

export interface HighlightsResponse {
  cell_id: number;
  highlights: Highlight[];
}

// Filter Parameters

export interface LeaderboardFilters {
  cell_id: number;
  segment?: string;
  keyword?: string;
  from_date?: string;
  to_date?: string;
  limit?: number;
  offset?: number;
}

export type RankingDataType =
  | IDataEmailReportingList
  | IDataTrainingCompletionList
  | IDataBadgeAchievementList;

export type GroupingDataType =
  | IGroupEmailReportingList
  | IGroupTrainingCompletionList
  | IGroupBadgeAchievementList;
